var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.20801H14",
    stroke: "#3F4778",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.20801H12.5V13.208C12.5 13.4732 12.3946 13.7276 12.2071 13.9151C12.0196 14.1027 11.7652 14.208 11.5 14.208H4.5C4.23478 14.208 3.98043 14.1027 3.79289 13.9151C3.60536 13.7276 3.5 13.4732 3.5 13.208V4.20801Z",
    stroke: "#3F4778",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.20801V3.70801C5.5 3.04497 5.76339 2.40908 6.23223 1.94024C6.70107 1.4714 7.33696 1.20801 8 1.20801C8.66304 1.20801 9.29893 1.4714 9.76777 1.94024C10.2366 2.40908 10.5 3.04497 10.5 3.70801V4.20801",
    stroke: "#3F4778",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.20898V11.2105",
    stroke: "#3F4778",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.20898V11.2105",
    stroke: "#3F4778",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCardIcon);
export default __webpack_public_path__ + "static/media/delete-card-icon.01b2d81367605ff4ad7072c9c56863c4.svg";
export { ForwardRef as ReactComponent };